import SuccesCaseHeaderSection from "../../Organisms/SuccesCaseHeaderSection/SuccesCaseHeaderSection";
// import SuccessCaseRetoSection from "./../../Molecules/SuccessCaseRetoSection/SuccessCaseRetoSection";
// import SuccesCaseSolutionSection from "./../../Molecules/SuccessCaseSolutionSection/SuccesCaseSolutionSection";
// import SuccessCaseEffectSection from "./../../Molecules/SuccessCaseEffectSection/SuccessCaseEffectSection";
import { Button } from "./../../Atoms/Button/Button";
import OtherNews from "../../Organisms/OtherNews/OtherNews";
// import SolutionData from "./../../Organisms/SolutionData/SolutionData"; //Preguntar si se elimina este componente
import "./SuccessCase.scss";
import usePost from "../../../hooks/usePost";
import Loader from "../../Atoms/Loader/Loader";
import ReactMarkdown from "react-markdown";
import capitalizedFirstLetter from "../../../Services/capitalizedFirstLetter";
import { useScrollCtx } from "../../../store/providers/ScrollContext";
import ChangeableHeaderV2 from "../../Molecules/ChangeableHeaderV2/ChangeableHeaderV2";

const SuccessCase = ({ params }) => {
	const { post, loading } = usePost("casos-exito", params.id);
	const { dropdownHeader } = useScrollCtx();

	return (
		<>
			<ChangeableHeaderV2 basic appearSecondNavbar={dropdownHeader} />
			{loading && !post ? (
				<div className="mt-200">
					<Loader />
				</div>
			) : (
				<>
					<SuccesCaseHeaderSection
						title={capitalizedFirstLetter(post.titulo_esp)}
						img={post.multimedia[0].url}
					/>

					<div className="hypertext-width top-space-section">
						<ReactMarkdown>{post.contenido_esp}</ReactMarkdown>
					</div>

					<div className="max-width top-space-section successCase-button-container">
						<Button
							content="Ir a atrás"
							type="button light-blue outline"
							buttonRoute="/casos-de-exito"
						/>
					</div>
					<div className="top-space-section bottom-space-section">
						<OtherNews toGet="casos-exitos" succesCase slug={params.id} />
					</div>
				</>
			)}
		</>
	);
};

export default SuccessCase;
